module.exports = __webpack_public_path__ + "static/media/alarm-snooze.49ad8815.svg";